export default __webpack_public_path__ + "static/media/Dubai-Medium.936f2076.woff";